import { MarketPeriods } from "app/utils/const";
import dayjs from "dayjs";
import {
  getDataSimple,
  getDataWithParams as getDataWithParamsV2,
} from "../helpers/apiHelper";
import { getDataWithParams } from "../helpers/apiHelperV3";
import { urls } from "./urls";

const API_LANDING_PAGE = urls.data.API_LANDING_PAGE();

export const fetchMarketGraphData = (params: any): any => {
  const url = "/statistics/landing-page-us";

  if (params) {
    const newParams = Object.assign(params, {
      "number-of-snapshots": 200,
    });
    return getDataWithParamsV2(url, newParams);
  }

  return getDataSimple(url);
};

export const fetchClosedEventsForLandingPage = (): any => {
  const url = "statistics/closed-events";
  const after = dayjs().startOf("day").subtract(1, "days").unix();
  return getDataWithParamsV2(url, {
    "tag-ids": 1389,
    summarised: false,
    periods: MarketPeriods.FULL_EVENT,
    after: after,
    "include-prices": false,
  });
};

export const fetchDataForLandingPageGraphs = (
  params: Record<string, any>
): any => {
  return getDataWithParams(API_LANDING_PAGE, params);
};
